<template>
    <div class="col-md-12 col-lg-12 mobile_pr_15 summary-of-charges">
        <div class="white_box">
            <h1 class="heading1">4. Summary Of Additional Charges</h1>
            
            <!-- Charges Table -->
            <div class="charges-table-section mt-4">
                <table class="table table-bordered charges-table">
                    <thead>
                        <tr>
                            <th class="item-col">Item</th>
                            <th class="qty-col text-left">Qty</th>
                            <th class="cost-col text-right">Cost</th>
                            <th class="total-col text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr>
                            <td>Total Items</td>
                            <td>{{ totalItemsCount }}</td>
                            <td>-</td>
                            <td class="text-right">-</td>
                        </tr> -->
                        <!-- <tr>
                            <td>Splitting Charges</td>
                            <td>{{ totalItemsCount }}</td>
                            <td>-</td>
                            <td class="text-right">-</td>
                        </tr> -->
                        <tr v-if="isSplitShipment && chargeableAddressCount > 0">
                            <td>Split shipment handling per address (first address free)</td>
                            <td>{{ chargeableAddressCount }}</td>
                            <td class="text-right">{{ splitShipmentFeePerAddressFormatted }}</td>
                            <td class="text-right">{{ splitShipmentFeeTotalFormatted }}</td>
                        </tr>
                        <!-- <tr>
                            <td>Packaging - {{ packagingBoxType }}</td>
                            <td>{{ splitAddressesCount }}</td>
                            <td>-</td>
                            <td class="text-right">-</td>
                        </tr> -->
                        <tr class="total-row">
                            <td colspan="3"><strong>Total Additional Charges (Splitting and Packing)</strong></td>
                            <td class="total-row-value text-right"><strong>{{ totalAdditionalChargesFormatted }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Disclaimer -->
           
        </div>
        <div class="disclaimer">
            <p class="text-muted small">
                Disclaimer: Final Kitting Costs May Be More Or Less Than Shown, This Amount Should Be Considered An Estimate. Shipping Costs Can Vary Significantly Based On Location.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "SummaryOfAdditionalCharges",
    computed: {
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        },
        splitAddresses() {
            const splitShipmentModule = this.$store.state.splitShipment;
            const addresses = splitShipmentModule && splitShipmentModule.splitAddresses;
            return Array.isArray(addresses) ? addresses : [];
        },
        splitAddressesCount() {
            return this.splitAddresses.length;
        },
        productAssignments() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.productAssignments || {};
        },
        totalItemsCount() {
            // Count total assigned items
            let total = 0;
            Object.keys(this.productAssignments).forEach(key => {
                if (this.productAssignments[key] && this.productAssignments[key].selected) {
                    total += this.productAssignments[key].quantity || 1;
                }
            });
            return total;
        },
        packagingOptions() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.packagingOptions || {
                boxType: 'standard',
                specialHandling: false
            };
        },
        packagingBoxType() {
            const boxType = this.packagingOptions.boxType || 'standard';
            return boxType.charAt(0).toUpperCase() + boxType.slice(1) + ' Box';
        },
        // Addresses that have at least one product assigned
        totalAddressesWithProducts() {
            const assignments = this.productAssignments || {};
            const indices = new Set();
            Object.keys(assignments).forEach(key => {
                const a = assignments[key];
                if (a && a.selected && a.addressIndex !== undefined) indices.add(a.addressIndex);
            });
            return indices.size;
        },
        // First address free; charge for (count - 1)
        chargeableAddressCount() {
            const n = this.totalAddressesWithProducts;
            return n <= 1 ? 0 : n - 1;
        },
        splitShipmentFeePerAddress() {
            const opt = this.$store.getters.getAdminOption && this.$store.getters.getAdminOption('split_shipment_fee_per_address');
            const val = opt && opt.option_value != null ? String(opt.option_value).replace(/[^0-9.]/g, '') : '';
            return parseFloat(val) || 0;
        },
        splitShipmentFeePerAddressFormatted() {
            return this.chargeableAddressCount > 0 ? '$' + this.splitShipmentFeePerAddress.toFixed(2) : '-';
        },
        splitShipmentFeeTotal() {
            return this.chargeableAddressCount * this.splitShipmentFeePerAddress;
        },
        splitShipmentFeeTotalFormatted() {
            return this.chargeableAddressCount > 0 ? '$' + this.splitShipmentFeeTotal.toFixed(2) : '-';
        },
        totalAdditionalChargesFormatted() {
            const total = this.splitShipmentFeeTotal || 0;
            return total > 0 ? '$' + total.toFixed(2) : '-';
        }
    }
};
</script>

<style scoped>
.summary-of-charges {
    padding: 20px 0;
    margin-bottom: 80px;
}

.summary-of-charges .white_box {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: 24px 32px;
}

.summary-of-charges .heading1 {
    font-size: 20px;
    font-weight: 600;
    color: #121212;
    line-height: 24px;
    margin-bottom: 4px;
}

.summary-of-charges .charges-table-section {
    margin-top: 24px;
    /* Scrollable body with sticky header */
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: auto;
}

.summary-of-charges .charges-table {
    width: 100%;
    border-collapse: collapse;
    border: none;
    margin-bottom: 0px;
}

.summary-of-charges .charges-table thead th {
    background: #F4F4F4;
    font-weight: 600 ;
    font-size: 14px;
    padding: 12px 16px;
    border: none;
    border: 1px solid #BEBEBE4D;
    vertical-align: middle;
    position: sticky;
    top: 0;
    z-index: 1;
    color: #121212;
    font-family: 'mulish';
}

.summary-of-charges .charges-table .item-col {
    text-align: left;
}

.summary-of-charges .charges-table .qty-col,
.summary-of-charges .charges-table .cost-col,
.summary-of-charges .charges-table .total-col {
    text-align: right;
}

.summary-of-charges .charges-table tbody td {
    padding: 12px 16px;
    border: 1px solid #BEBEBE4D;
    vertical-align: middle;
    font-size: 14px;
    color: #121212;
    font-weight: 500;
    font-family: 'mulish';
}

.summary-of-charges .charges-table tbody tr:last-child td {
    border-bottom: none;
}

.summary-of-charges .charges-table .total-row td {
    font-weight: 700;
    font-size: 16px;
    color: #121212;
    font-family: 'mulish';
}
.summary-of-charges .charges-table .total-row{
    border-bottom: 1px solid #BEBEBE4D; 
}
.summary-of-charges .charges-table .total-row td .total-row-value{
    font-size: 24px;
    font-weight: 700;
}
.summary-of-charges .charges-table .total-row td:last-child {
    font-size: 24px;
    font-weight: 700;
    line-height: 24px;
    color: #121212;
    font-family: 'mulish';
}

.summary-of-charges .heading1{
    font-size: 20px !important;
}
.disclaimer {
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin-top: 16px;
    position: absolute;
    bottom: -10px;
}
.disclaimer p{
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin: 0px;
}

@media (max-width: 991px) {
    .summary-of-charges {
        padding: 16px 0;
        margin-bottom: 64px;
    }

    .summary-of-charges .white_box {
        padding: 20px 18px;
    }

    .summary-of-charges .heading1 {
        font-size: 22px !important;
        line-height: 30px;
    }

    .summary-of-charges .charges-table-section {
        max-height: 46vh;
        margin-top: 16px;
    }

    .summary-of-charges .charges-table thead th,
    .summary-of-charges .charges-table tbody td {
        padding: 10px 12px;
    }

    .summary-of-charges .charges-table .total-row td:last-child {
        font-size: 20px;
        line-height: 22px;
    }

    .disclaimer {
        position: static;
        margin-top: 10px;
    }
}

@media (max-width: 767px) {
    .summary-of-charges .white_box {
        padding: 18px 14px;
    }

    .summary-of-charges .heading1 {
        font-size: 20px !important;
        line-height: 28px;
    }

    .summary-of-charges .charges-table-section {
        margin-top: 12px;
        max-height: none;
    }

    .summary-of-charges .charges-table {
        min-width: 640px;
    }

    .summary-of-charges .charges-table thead th {
        font-size: 13px;
        padding: 10px;
    }

    .summary-of-charges .charges-table tbody td {
        font-size: 13px;
        padding: 10px;
    }

    .summary-of-charges .charges-table .total-row td {
        font-size: 14px;
    }

    .summary-of-charges .charges-table .total-row td:last-child {
        font-size: 18px;
        line-height: 20px;
    }

    .disclaimer p {
        line-height: 16px;
    }
}

@media (max-width: 575px) {
    .summary-of-charges {
        margin-bottom: 48px;
    }

    .summary-of-charges .white_box {
        padding: 14px 10px;
    }

    .summary-of-charges .heading1 {
        font-size: 18px !important;
        line-height: 24px;
    }

    .summary-of-charges .charges-table {
        min-width: 560px;
    }

    .summary-of-charges .charges-table thead th,
    .summary-of-charges .charges-table tbody td {
        padding: 8px;
    }

    .summary-of-charges .charges-table .total-row td:last-child {
        font-size: 16px;
        line-height: 18px;
    }

    .disclaimer,
    .disclaimer p {
        font-size: 11px;
        line-height: 15px;
    }
}
</style>
